import { type InitFlowComponent, useSettings } from '@capsicum/common';
import { useAccountManagement } from '@capsicum/socios-core';
import { type ComponentProps } from 'react';

type UseNCWInitFlowEnabledProps = {
	isReactive: ComponentProps<InitFlowComponent>['isReactive'];
};

export const useNCWInitFlowEnabled = ({ isReactive }: UseNCWInitFlowEnabledProps) => {
	const { isDeletionOngoing, isLoading: isAccountManagementLoading } = useAccountManagement();

	const {
		areSettingsLoading,
		settings: { isNCWCreationFlowEnabled, isPoblanoEnabled }
	} = useSettings();

	return {
		isEnabled:
			isReactive && isPoblanoEnabled && !isDeletionOngoing && !areSettingsLoading && isNCWCreationFlowEnabled,
		isLoading: areSettingsLoading || isAccountManagementLoading
	};
};
